var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "action",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08362 0.600435C4.24591 0.235289 4.60801 0 5.00754 0H12.9933C13.7449 0 14.2338 0.790947 13.8976 1.46324L11.6261 6.00635H14.9875C15.8882 6.00635 16.3393 7.0954 15.7024 7.73236L3.73676 19.698C2.98233 20.4524 1.72526 19.6754 2.06264 18.6633L4.61321 11.0116H1.01221C0.280524 11.0116 -0.208873 10.2585 0.088281 9.58994L4.08362 0.600435Z",
    fill: "#8D90A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.7c33098071f5eda6af70bffde3b5756d.svg";
export { ForwardRef as ReactComponent };